import { FC, PropsWithChildren } from 'react';
import { StyledFieldWrapper } from './styles';
import { borderRadii } from 'app/spacing';

export const WithDashedBorder: FC<
  PropsWithChildren<{
    dashedBorder: boolean;
  }>
> = ({ children, ...rest }) => (
  <StyledFieldWrapper {...rest}>
    {children}
    {rest.dashedBorder ? (
      <svg
        width="100%"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
        className="absolute top-0 left-0 pointer-events-none"
      >
        <rect
          width="100%"
          height="100%"
          fill="none"
          stroke="var(--color-border-medium)"
          rx={borderRadii.standard}
          ry={borderRadii.standard}
          strokeWidth="2"
          strokeDasharray="4"
          strokeDashoffset="1"
          strokeLinecap="butt"
        />
      </svg>
    ) : null}
  </StyledFieldWrapper>
);
